import React from 'react';
import { Star, Quote } from 'lucide-react';

const reviews = [
  {
    id: 1,
    quote: "Sehr kompetente Beratung und saubere Installation. Die Anlage läuft perfekt.",
    name: "Familie M.",
    location: "Weilmünster",
    rating: 5
  },
  {
    id: 2,
    quote: "Von der Planung bis zur Umsetzung alles sehr professionell. Herr Kaufmann hat sich viel Zeit für unsere Fragen genommen.",
    name: "Thomas K.",
    location: "Erftstadt",
    rating: 5
  },
  {
    id: 3,
    quote: "Wir würden Sunprojects jederzeit wieder beauftragen. Kompetent, zuverlässig und fair im Preis.",
    name: "Ehepaar S.",
    location: "Köln",
    rating: 5
  },
  {
    id: 4,
    quote: "Endlich ein Anbieter, der nicht nur verkaufen will, sondern wirklich berät. Unsere Anlage produziert sogar mehr als prognostiziert!",
    name: "Andrea W.",
    location: "Limburg",
    rating: 5
  },
  {
    id: 5,
    quote: "Transparente Kommunikation, pünktliche Umsetzung und top Qualität. So muss das sein.",
    name: "Markus B.",
    location: "Bad Camberg",
    rating: 5
  },
  {
    id: 6,
    quote: "Nach vielen Angeboten haben wir uns für Sunprojects entschieden – die beste Entscheidung. Absolute Empfehlung!",
    name: "Familie H.",
    location: "Villmar",
    rating: 5
  }
];

const StarRating = ({ rating }) => {
  return (
    <div className="flex gap-1">
      {[...Array(rating)].map((_, i) => (
        <Star key={i} className="w-5 h-5 text-amber-400 fill-amber-400" />
      ))}
    </div>
  );
};

const CustomerReviewsSection = () => {
  return (
    <section data-testid="customer-reviews-section" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-amber-100 text-amber-700 rounded-full text-sm font-semibold mb-4">
            Kundenstimmen
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Das sagen unsere
            <span className="text-sun-orange"> Kunden</span>
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            Viele Eigenheimbesitzer vertrauen bereits auf Sunprojects für ihre Photovoltaikprojekte. 
            Lesen Sie, was unsere Kunden über die Zusammenarbeit berichten.
          </p>
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((review) => (
            <div
              key={review.id}
              data-testid={`review-card-${review.id}`}
              className="group bg-gradient-to-br from-slate-50 to-white rounded-2xl p-8 border border-slate-100 hover:border-sun-orange/30 hover:shadow-xl hover:shadow-sun-orange/5 transition-all duration-300"
            >
              {/* Quote Icon */}
              <div className="w-12 h-12 bg-sun-orange/10 rounded-xl flex items-center justify-center mb-5 group-hover:bg-sun-orange transition-colors">
                <Quote className="w-6 h-6 text-sun-orange group-hover:text-white transition-colors" />
              </div>
              
              {/* Star Rating */}
              <StarRating rating={review.rating} />
              
              {/* Quote Text */}
              <p className="text-slate-700 leading-relaxed mt-4 mb-6 text-base">
                "{review.quote}"
              </p>
              
              {/* Customer Info */}
              <div className="pt-4 border-t border-slate-100">
                <p className="font-semibold text-slate-900">{review.name}</p>
                <p className="text-sm text-slate-500">{review.location}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Summary */}
        <div className="mt-14 text-center">
          <div className="inline-flex items-center gap-4 px-8 py-5 bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200/50 rounded-2xl">
            <div className="flex -space-x-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-6 h-6 text-amber-400 fill-amber-400" />
              ))}
            </div>
            <div className="text-left">
              <p className="font-bold text-slate-900">Durchschnittlich 5 Sterne</p>
              <p className="text-sm text-slate-600">Basierend auf Kundenfeedback</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomerReviewsSection;
